module.exports = __webpack_public_path__ + "img/solutionImg4.106fb0e8.png";